WiseMetering.Collection.Integrations = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.Integration,
    url: '/integrations'
});
